import { ENABLE_I18N, LANGUAGES, useI18n } from "@/lib/i18n";

/* Inline SVG flags — crisp at any size, no external dependency. */
const Flag = ({ code }) => {
  const cls = "block w-full h-full";
  if (code === "de") {
    return (
      <svg viewBox="0 0 5 3" className={cls} preserveAspectRatio="none" aria-hidden="true">
        <rect width="5" height="1" fill="#000" />
        <rect y="1" width="5" height="1" fill="#D00" />
        <rect y="2" width="5" height="1" fill="#FFCE00" />
      </svg>
    );
  }
  if (code === "fr") {
    return (
      <svg viewBox="0 0 3 2" className={cls} preserveAspectRatio="none" aria-hidden="true">
        <rect width="1" height="2" fill="#002654" />
        <rect x="1" width="1" height="2" fill="#fff" />
        <rect x="2" width="1" height="2" fill="#ED2939" />
      </svg>
    );
  }
  if (code === "en") {
    return (
      <svg viewBox="0 0 60 30" className={cls} preserveAspectRatio="none" aria-hidden="true">
        <clipPath id="fk-uk-clip">
          <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
        </clipPath>
        <rect width="60" height="30" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
        <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#fk-uk-clip)" stroke="#C8102E" strokeWidth="4" />
        <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
      </svg>
    );
  }
  if (code === "it") {
    return (
      <svg viewBox="0 0 3 2" className={cls} preserveAspectRatio="none" aria-hidden="true">
        <rect width="1" height="2" fill="#009246" />
        <rect x="1" width="1" height="2" fill="#fff" />
        <rect x="2" width="1" height="2" fill="#CE2B37" />
      </svg>
    );
  }
  return null;
};

/**
 * Sprachschalter im Header — mit Flaggen + Code.
 * Hard-off via ENABLE_I18N.
 */
export default function LanguageSwitcher({ className = "" }) {
  const { lang, setLang } = useI18n();

  if (!ENABLE_I18N) return null;

  return (
    <div
      data-testid="lang-switcher"
      role="group"
      aria-label="Sprache wählen"
      className={`flex items-center gap-1 ${className}`}
    >
      {LANGUAGES.map((l) => {
        const active = l.code === lang;
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => setLang(l.code)}
            data-testid={`lang-${l.code}`}
            aria-pressed={active}
            title={l.name}
            className={`group inline-flex items-center gap-1.5 px-2 py-1.5 transition-colors duration-200 ${
              active
                ? "text-white"
                : "text-zinc-500 hover:text-white"
            }`}
          >
            <span
              className={`block w-[18px] h-[12px] overflow-hidden ring-1 transition-all duration-200 ${
                active
                  ? "ring-white/60 shadow-[0_0_0_2px_rgba(255,255,255,0.08)]"
                  : "ring-white/15 grayscale-[40%] opacity-80 group-hover:grayscale-0 group-hover:opacity-100 group-hover:ring-white/40"
              }`}
            >
              <Flag code={l.code} />
            </span>
            <span className="hidden xl:inline text-[11px] font-semibold tracking-[0.18em] uppercase">
              {l.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
